// Typelizer digest 455f308254a3846d17174dfddd826a90
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /learners/relief_listings/invitations/:invitation_id/response/new */
  new: (
    params: { invitationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/relief_listings/invitations/:invitation_id/response/new', params, options),
    method: 'get',
  }),

  /** GET /learners/relief_listings/invitations/:invitation_id/response */
  show: (
    params: { invitationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/relief_listings/invitations/:invitation_id/response', params, options),
    method: 'get',
  }),

  /** POST /learners/relief_listings/invitations/:invitation_id/response */
  create: (
    params: { invitationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/relief_listings/invitations/:invitation_id/response', params, options),
    method: 'post',
  }),
}
